export const Logo = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_2"
    viewBox="0 0 200 200"
    {...props}
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1={174.41}
        x2={25.26}
        y1={170.89}
        y2={28.8}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#322f82" />
        <stop offset={0.19} stopColor="#403fa4" />
        <stop offset={0.42} stopColor="#4f50c5" />
        <stop offset={0.64} stopColor="#5a5cde" />
        <stop offset={0.83} stopColor="#6063ec" />
        <stop offset={1} stopColor="#6366f2" />
      </linearGradient>
      <filter id="drop-shadow-1" filterUnits="userSpaceOnUse">
        <feOffset />
        <feGaussianBlur result="blur" stdDeviation={2} />
        <feFlood floodColor="#4438c9" floodOpacity={0.75} />
        <feComposite in2="blur" operator="in" />
        <feComposite in="SourceGraphic" />
      </filter>
      <style>{'.cls-2{fill:#fff}'}</style>
    </defs>
    <g id="Layer_1-2">
      <rect
        width={200}
        height={200}
        rx={32}
        ry={32}
        style={{
          fill: 'url(#linear-gradient)',
        }}
      />
      <g
        style={{
          filter: 'url(#drop-shadow-1)',
        }}
      >
        <path
          d="M64.64 140.13c9.3-11.23 21.79-17.41 35.18-17.41s25.88 6.18 35.18 17.41l.17.2c.54.66 1.53.72 2.14.11l10.49-10.49c.42-.42.54-1.07.29-1.62 0 0-31.51-106.08-48.08-106.08-16.57 0-48.08 106.08-48.08 106.08-.25.55-.13 1.19.29 1.62l10.29 10.29c.6.6 1.59.55 2.13-.1h.01Z"
          className="cls-2"
        />
        <path
          d="M99.81 138.7h-.3c-14.2.16-21.16 17.4-11.12 27.44l11.6 11.6 11.33-11.33c10.14-10.14 3.11-27.54-11.22-27.7h-.3Z"
          className="cls-2"
        />
      </g>
    </g>
  </svg>
);
